/**
 * The three widths that make the desktop wall chart line up.
 *
 * The habit row and the date header are separate components drawn in separate
 * places, so their geometry lives here rather than being typed twice and
 * drifting the first time someone adjusts a name column.
 *
 * Each width appears twice: once as the Tailwind class that draws it, once as
 * the number the app measures with when deciding how many days fit. Tailwind
 * needs literal class names, so the pair cannot be derived — KEEP THEM IN STEP.
 */

/** Grip + habit name: the block that sticks to the left edge while days scroll. */
export const LEAD_WIDTH = 'w-60';
export const LEAD_PX = 240;

/** One past day. */
export const DAY_TRACK = 'w-7';
export const DAY_TRACK_PX = 28;

/** Today. Wider because the completion circle lives here, and it is a real
 *  touch target rather than a 16px square. */
export const TODAY_TRACK = 'w-11';
export const TODAY_TRACK_PX = 44;
